// A form outcome thrown as an Error so it can carry the reported failure as `cause`.
export class AuthFlowError<Kind extends string> extends Error {
  constructor(
    public readonly kind: Kind,
    options?: ErrorOptions,
  ) {
    super(`Auth flow failed: ${kind}`, options);
    this.name = 'AuthFlowError';
  }
}
